import { Link } from 'react-router-dom';
import { Bookmark } from 'lucide-react';
const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Style 3: Solid-colored stack (left) + compact text grid + 1 big food card (right) — for Društvo
export default function Style3Block({ category, articles }) {
  if (!articles || articles.length === 0) return null;
  const color = category.color || '#1e90ff';
  const leftCards = articles.slice(0, 5);      // colored-bg stack
  const rightCards = articles.slice(5, 11);    // compact 2×3 text
  const bigRight = articles[11] || articles[0]; // big image card at bottom

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 lg:divide-x lg:divide-gray-200 dark:lg:divide-gray-800" data-testid="style3-block">
      {/* LEFT: colored stack */}
      <div className="space-y-3 lg:pr-6">
        {leftCards.map(a => {
          const coverUrl = a.cover_image_url?.startsWith('http') ? a.cover_image_url : `${BACKEND}${a.cover_image_url}`;
          return (
            <Link key={a.id} to={`/clanak/${a.slug}`} className="group flex gap-3 rounded-lg p-3 relative" style={{ backgroundColor: color }} data-testid={`style3-colored-${a.id}`}>
              {a.cover_image_url && (
                <div className="shrink-0 w-24 h-20 rounded overflow-hidden">
                  <img src={coverUrl} alt="" className="w-full h-full object-cover" loading="lazy" />
                </div>
              )}
              <div className="flex-1 min-w-0 text-white">
                <span className="inline-block text-[9px] font-bold uppercase tracking-wider bg-white/20 px-1.5 py-0.5 rounded mb-1">{category.name_hr}</span>
                <h4 className="text-sm font-bold leading-snug line-clamp-2 group-hover:underline">{a.title_hr}</h4>
                <p className="text-[10px] text-white/70 mt-1 uppercase tracking-wide">{a.published_at ? new Date(a.published_at).toLocaleDateString('hr') : ''}</p>
              </div>
              <Bookmark size={14} className="absolute top-3 right-3 text-white/70 group-hover:text-white" />
            </Link>
          );
        })}
      </div>

      {/* RIGHT: compact grid + big image bottom */}
      <div className="lg:pl-6 mt-4 lg:mt-0 flex flex-col">
        <div className="grid grid-cols-2 gap-3 flex-1">
          {rightCards.map(a => (
            <Link key={a.id} to={`/clanak/${a.slug}`} className="group relative p-3 bg-violet-50 dark:bg-violet-900/20 rounded-lg" data-testid={`style3-compact-${a.id}`}>
              <span className="inline-block text-[9px] font-bold uppercase tracking-wider bg-violet-200 dark:bg-violet-800 text-violet-800 dark:text-violet-200 px-1.5 py-0.5 rounded mb-1">{category.name_hr}</span>
              <h4 className="text-sm font-bold leading-snug line-clamp-3 text-gray-900 dark:text-white group-hover:text-red-600">{a.title_hr}</h4>
              <p className="text-[10px] text-gray-400 mt-1 uppercase">{a.published_at ? new Date(a.published_at).toLocaleDateString('hr') : ''}</p>
              <Bookmark size={12} className="absolute bottom-2 right-2 text-gray-400 group-hover:text-red-600" />
            </Link>
          ))}
        </div>
        {bigRight && bigRight.cover_image_url && (
          <Link to={`/clanak/${bigRight.slug}`} className="mt-3 relative h-48 rounded-lg overflow-hidden group" data-testid="style3-big">
            <img src={bigRight.cover_image_url?.startsWith('http') ? bigRight.cover_image_url : `${BACKEND}${bigRight.cover_image_url}`} alt="" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
            <div className="absolute bottom-3 left-3 right-3 text-white">
              <h4 className="text-base font-bold line-clamp-2">{bigRight.title_hr}</h4>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
}
